import { Fragment, jsx } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { cloneElement, useState } from "react";
import Tooltip from "@mui/material/Tooltip";
import ClickAwayListener from "@mui/material/ClickAwayListener";
import { useActionOnScroll, useIsDesktop, useIsInsideContainer } from "../hooks/index.js";
import Tooltip_styles from "./Tooltip.styles.js";
function _define_property(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if ("function" == typeof Object.getOwnPropertySymbols) ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function Tooltip_ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = null != source ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else Tooltip_ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}
const Tooltip_Tooltip = (t0)=>{
    const $ = c(42);
    const { children, title, placement: t1, disabled: t2, interactive: t3, maxWidth, onOpen, onClose, inverted: t4, enterDelay, testId: t5 } = t0;
    const placement = void 0 === t1 ? "right" : t1;
    const disabled = void 0 === t2 ? false : t2;
    const interactive = void 0 === t3 ? false : t3;
    const inverted = void 0 === t4 ? false : t4;
    const testId = void 0 === t5 ? "tooltip-test-id" : t5;
    let t6;
    if ($[0] !== inverted || $[1] !== maxWidth) {
        t6 = {
            inverted,
            maxWidth
        };
        $[0] = inverted;
        $[1] = maxWidth;
        $[2] = t6;
    } else t6 = $[2];
    const { classes } = Tooltip_styles(t6);
    const isDesktop = useIsDesktop();
    const isInsideContainer = useIsInsideContainer();
    const [open, setOpen] = useState(false);
    let t7;
    if ($[3] !== onClose || $[4] !== onOpen) {
        t7 = ()=>{
            setOpen((prevState)=>{
                if (prevState) null == onClose || onClose();
                else null == onOpen || onOpen();
                return !prevState;
            });
        };
        $[3] = onClose;
        $[4] = onOpen;
        $[5] = t7;
    } else t7 = $[5];
    const handleToggle = t7;
    let t8;
    if ($[6] !== onClose || $[7] !== open) {
        t8 = ()=>{
            if (open) {
                setOpen(false);
                null == onClose || onClose();
            }
        };
        $[6] = onClose;
        $[7] = open;
        $[8] = t8;
    } else t8 = $[8];
    const handleClickAway = t8;
    const t9 = !isDesktop && !disabled && open;
    const t10 = isInsideContainer ? null : void 0;
    let t11;
    if ($[9] !== handleClickAway || $[10] !== t10 || $[11] !== t9) {
        t11 = {
            active: t9,
            onAction: handleClickAway,
            scrollSelector: t10
        };
        $[9] = handleClickAway;
        $[10] = t10;
        $[11] = t9;
        $[12] = t11;
    } else t11 = $[12];
    useActionOnScroll(t11);
    if (disabled) {
        let t12;
        if ($[13] !== children) {
            t12 = /*#__PURE__*/ jsx(Fragment, {
                children: children
            });
            $[13] = children;
            $[14] = t12;
        } else t12 = $[14];
        return t12;
    }
    const t12 = !interactive;
    let t13;
    if ($[15] !== classes || $[16] !== enterDelay || $[17] !== placement || $[18] !== t12 || $[19] !== testId || $[20] !== title) {
        t13 = {
            classes,
            arrow: true,
            title,
            placement,
            disableInteractive: t12,
            enterDelay,
            className: "aqa_tooltip",
            "data-testid": testId
        };
        $[15] = classes;
        $[16] = enterDelay;
        $[17] = placement;
        $[18] = t12;
        $[19] = testId;
        $[20] = title;
        $[21] = t13;
    } else t13 = $[21];
    const tooltipProps = t13;
    let t14;
    if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
        t14 = [
            {
                name: "offset",
                options: {
                    offset: [
                        0,
                        -4
                    ]
                }
            }
        ];
        $[22] = t14;
    } else t14 = $[22];
    const popperModifiers = t14;
    if (!isDesktop) {
        let t15;
        if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
            t15 = {
                popper: {
                    modifiers: popperModifiers
                }
            };
            $[23] = t15;
        } else t15 = $[23];
        const t16 = children;
        let t17;
        if ($[24] !== handleToggle) {
            t17 = (e)=>{
                e.stopPropagation();
                handleToggle();
            };
            $[24] = handleToggle;
            $[25] = t17;
        } else t17 = $[25];
        let t18;
        if ($[26] !== t16 || $[27] !== t17) {
            t18 = /*#__PURE__*/ cloneElement(t16, {
                onClick: t17
            });
            $[26] = t16;
            $[27] = t17;
            $[28] = t18;
        } else t18 = $[28];
        let t19;
        if ($[29] !== open || $[30] !== t18 || $[31] !== tooltipProps) {
            t19 = /*#__PURE__*/ jsx(Tooltip, _object_spread_props(_object_spread({}, tooltipProps), {
                open: open,
                disableFocusListener: true,
                disableHoverListener: true,
                disableTouchListener: true,
                slotProps: t15,
                children: t18
            }));
            $[29] = open;
            $[30] = t18;
            $[31] = tooltipProps;
            $[32] = t19;
        } else t19 = $[32];
        let t20;
        if ($[33] !== handleClickAway || $[34] !== t19) {
            t20 = /*#__PURE__*/ jsx(ClickAwayListener, {
                onClickAway: handleClickAway,
                children: t19
            });
            $[33] = handleClickAway;
            $[34] = t19;
            $[35] = t20;
        } else t20 = $[35];
        return t20;
    }
    let t15;
    if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
        t15 = {
            popper: {
                modifiers: popperModifiers
            }
        };
        $[36] = t15;
    } else t15 = $[36];
    let t16;
    if ($[37] !== children || $[38] !== onClose || $[39] !== onOpen || $[40] !== tooltipProps) {
        t16 = /*#__PURE__*/ jsx(Tooltip, _object_spread_props(_object_spread({}, tooltipProps), {
            enterTouchDelay: 0,
            onOpen: onOpen,
            onClose: onClose,
            slotProps: t15,
            children: children
        }));
        $[37] = children;
        $[38] = onClose;
        $[39] = onOpen;
        $[40] = tooltipProps;
        $[41] = t16;
    } else t16 = $[41];
    return t16;
};
export { Tooltip_Tooltip as Tooltip };
